import axios from "axios";
import { API, BEARER } from "../constant";
import { getToken } from "../helpers";

const token = getToken();

export const getTags = async () => {
  const response = await axios
    .get(`${API}/api/tags?pagination[pageSize]=100`)
    .then(({ data }) => data.data)
    .catch((err) => console.error(err))
    .finally(() => {});
  return response;
};

export const postTag = async (name) => {
  const response = await axios
    .post(
      `${API}/api/tags`,
      { data: { name } },
      { headers: { Authorization: `${BEARER} ${token}` } }
    )
    .then(({ data }) => data)
    .catch((err) => {
      console.error(err);
    })
    .finally(() => {});
  return response;
};
